import { SegmentedControlProps } from './SegmentedControl.types';
import * as Styled from './SegmentedControl.styles';

/**
 * The monitor's pick-one control: MUI's exclusive ToggleButtonGroup in the app's toggle style
 * (`ui/daysSelector`). Exactly one option is selected at any time - clicking the selected option
 * again keeps it, so a range or a source can never be "none".
 */
export const SegmentedControl = <T extends string>({
  value,
  options,
  onChange,
  label,
  ariaLabel,
  testId,
}: SegmentedControlProps<T>): JSX.Element => (
  <div data-testid={testId}>
    {label && <Styled.Label>{label}</Styled.Label>}
    <Styled.Group
      exclusive
      size="small"
      value={value}
      aria-label={ariaLabel ?? label}
      onChange={(_event, next: T | null) => {
        if (next !== null && next !== value) {
          onChange(next);
        }
      }}
    >
      {options.map((option) => (
        <Styled.Option key={option.value} value={option.value} disabled={option.disabled}>
          {option.label}
        </Styled.Option>
      ))}
    </Styled.Group>
  </div>
);
